export default __webpack_public_path__ + "static/media/description.8687ab2a.png";